module.exports = __webpack_public_path__ + "static/media/the-halley-incident.f1b9eaff.jpg";